/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type { Task } from 'ember-concurrency';

interface CioAsyncModalButtonSignature<T = void> {
  Element: HTMLSpanElement;
  Args: {
    buttonText?: string;
    buttonClass?: string;
    disabled?: boolean;
    pendingTitle?: string;
    pendingVideo?: string;
    successTitle?: string;
    successVideo?: string;
    successText?: string;
    successRoute?: string;
    failureTitle?: string;
    failureVideo?: string;
    onStart: () => Promise<T>;
    onClose: () => unknown;
    mediaContainerId?: string;
  };
  Blocks: {
    default: [promise: Task<undefined, [T]>];
  };
}

export default class CioAsyncModalButton<T = void> extends Component<CioAsyncModalButtonSignature<T>> {
  @tracked isOpen = false;

  get buttonClass() {
    return this.args.buttonClass ?? 'fly-btn';
  }

  get disabled() {
    return this.args.disabled ?? false;
  }

  @action
  start() {
    this.isOpen = true;
  }

  @action
  closeModal() {
    this.isOpen = false;

    if (this.args.onClose != null) {
      this.args.onClose();
    }
  }
}
